import {React, useState} from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { Button } from 'react-bootstrap';
import charImg from "../assets/projects/char.png";
import detectAi from "../assets/projects/detect-ai.jpeg";
import deepImg from "../assets/projects/frost.jpeg";
import wavenet from "../assets/projects/wavenet.png";
import nlpCodeImg from "../assets/projects/nlp-to-code.png";

export const Project = () => {
    const cardsData = [
        { title: 'CharGPT', image: charImg, text: 'Languages/Libraries: Python, PyTorch', demoURL: 'https://github.com/jnuvvula9/CharGPT'},
        { title: 'Gen-AI-Text-Segmentation', image: detectAi, text: 'Languages/Libraries: Python, PyTorch, Pandas, Numpy, Transformers', demoURL: 'https://github.com/jnuvvula9/Gen-AI-Text-Segmentation' },
        { title: 'Frost Detection On Mars', image: deepImg, text: 'Libraries/Models: Python, Keras, Tensorflow, Pandas, ResNet50, VGG16', demoURL: 'https://github.com/jnuvvula9/frost-detection'},
        { title: 'Wave Net Architecture', image: wavenet, text: 'Languages/Libraries: Python, Pytorch', demoURL: 'https://github.com/jnuvvula9/WaveNet-Architecture-Implementation'},
        { title: 'Natural Language To Code', image: nlpCodeImg, text: 'Languages/Libraries: Python, Keras, TensorFlow, Transformers, SentencePeice, CodeT5', demoURL: 'https://github.com/jnuvvula9/Natural-Language-to-Code'},
       
        // ...more cards
      ];
      const handleRedirect = (url) => {
        console.log(`Redirecting to ${url}`);
        window.location.href = url;
      };

      const MyCard = ({ title, image, text, demoURL }) => (
        <Grid item xs={12} sm={6} md={4}>
            <Card sx={{ height: '380px', display: 'flex', flexDirection: 'column' }}> 
                <CardMedia component="img" image={image} alt={title} sx={{ height: '170px' }} /> {/* Fixed height for image */}
                    <CardContent sx={{ flexGrow: 1, overflow: 'auto' }}> {/* Content area with scroll if needed */}
                        <Typography gutterBottom variant="h5" component="h2">
                        {title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                        {text}
                        </Typography>
                    </CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                <a href= {demoURL} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faGithub} className="social-icon icon-github" style= {{color:'black'}} />
                    </a>
                {/* <Button className='custom-button'
                    onClick={() => window.location.href = demoURL}
                >
                        Github
                    </Button> */}
                </Box>
            </Card>
        </Grid>
      );
  return (
    <section id = 'projects'>
        <h1 className='header-skillset' style={{marginBottom: '30px'}}>Projects</h1>
        <Grid container spacing={2} sx={{ marginX: 'auto', maxWidth: 'lg', paddingX: 3 }}>
            {cardsData.map((card, index) => (
                <MyCard key={index} title={card.title} image={card.image} text={card.text} demoURL={card.demoURL} />
            ))}
        </Grid>
    </section>
  )
}
